import type { NextPage } from 'next';
import KnearComponent from '@components/projects/knear/knear';
import ProjectLayout from '@layouts/project-layout/project-layout';
import { Themes } from '@layouts/main-layout/themes.enum';
import { ProjectProps } from '@models/project.interface';

const Knear: NextPage<ProjectProps> = (project) => {
  return (
    <ProjectLayout theme={Themes.Dark} project={project}>
      <KnearComponent breadcrumbsText={project.project.breadcrumbsText} />
    </ProjectLayout>
  );
};

export default Knear;

export { getServerSideProps } from '@layouts/project-layout/project-layout';
